import React from 'react';

export default function FacilityCard({ facility, expanded, onExpand, onEdit, onDelete }) {
  return (
    <div className={`facility-card${expanded ? ' expanded' : ''}`} style={{ marginBottom: 12 }}>
      <div className="facility-card-header" onClick={onExpand}>
        <span className="facility-card-title">{facility.name}</span>
        <span style={{ marginLeft: 'auto' }}>{expanded ? '▲' : '▼'}</span>
      </div>
      {expanded && (
        <div className="facility-card-details">
          <div><b>Description:</b> {facility.description}</div>
          <div><b>Price:</b> {facility.price} PKR</div>
          <div><b>Charge Type:</b> {facility.charge_type}</div>
          <div className="facility-card-actions" style={{ marginTop: 8 }}>
            <button className="btn-edit" onClick={onEdit}>Edit</button>
            <button className="btn-delete" onClick={onDelete}>Delete</button>
          </div>
        </div>
      )}
    </div>
  );
}
